<template>
  <div>
    <div class="row bg-success bg-opacity-10">
      <div class="text-title">
        <!--      <i class="bi-check-circle-fill" style="font-size: 2rem; color: #00FF00;"></i>-->
        <el-result icon="success" title="" sub-title="" style="margin-top: 40px"> </el-result>
        <span class="text-dark" style="font-size: 2rem;font-weight: bold;">
          支付成功
        </span>
      </div>
    </div>
    <div class="content">
      <div>
        <table>
          <tr>
            <td class="title">商品订单:</td>
            <td class="text-content">{{ id }}</td>
          </tr>
          <tr>
            <td class="title">商品名称:</td>
            <td class="text-content">{{ product }}</td>
          </tr>
          <tr>
            <td class="title">支付订单:</td>
            <td class="text-content">{{ order }}</td>
          </tr>
          <tr>
            <td class="title">支付金额:</td>
            <td class="text-content">¥{{ pay }}</td>
          </tr>
          <tr>
            <td class="title">支付方式:</td>
            <td class="text-content">{{ type }}</td>
          </tr>
          <tr>
            <td class="title">支付时间:</td>
            <td class="text-content">{{ date }}</td>
          </tr>
          <tr v-bind:style="{'display':visible?'':'none'}">
            <td class="title">序列号:</td>
            <td id="check" class="text-content">{{ license }}</td>
          </tr>
          <tr v-bind:style="{'display':visible?'':'none'}">
            <td class="title">注册码:</td>
            <td class="text-content">
              <div class="code">
                {{ booleanKey }}
              </div>
              <div style="color: red">
                <el-button type="primary" size="small" icon="el-icon-document-copy" @click="handleCopy">点击复制</el-button>
                *请务必将注册码复制、另存，避免遗失，否则无法激活！！！
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div style="color: #2966ff">
        <p>*注意：支付完成后：</p>
        <p>（1）建议将此页进行拍照留存。</p>
        <p>（2）请关闭窗口，前往应用软件进行验证。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getPaySuccessInfo } from '@/api/paySuccess'

export default {
  name: 'App',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      txt: '',
      visible: false,
      sale: '20130888882',
      product: 'EXE001',
      order: '008018028831084',
      pay: '10',
      type: '微信',
      date: '2023-6-24 13:00',
      license: 'jsp0012345678',
      booleanKey: 'adangajlnangalngangnalglngalngljlen',
      id: ''
    }
  },
  mounted() {
    // document.getElementById('app').style.display = 'block';
    // document.getElementById('appLoading').style.display = 'none';
    // this.txt = document.getElementById('check').innerText
    // if (this.txt !== '') {
    //   this.visible = true
    // } else {
    //   this.visible = false
    // }
    // console.log('输出：' + this.visible)
    // this.id = '20230606120910925525'
    this.id = this.$route.query.id
    this.getResultInfo()
  },
  methods: {
    // handle(formName) {
    // }
    handleCopy() {
      this.$copyText(this.booleanKey).then(
        e => {
          console.log('复制成功：', e)
          this.$message({
            message: '已成功复制注册码',
            type: 'success'
          })
        }
      ).catch(
        e => {
          console.log('复制失败：', e)
          this.$message.error('复制失败了')
        }
      )
    },
    getResultInfo() {
      // 定义参数
      var params = {
        'id': this.id
      }
      getPaySuccessInfo(params).then((res) => {
        console.log('获得返回支付结果数据0')
        console.log(res)
        console.log(res['code'])
        if (res['code'] === 200) {
          this.product = res['data']['oname']
          this.order = res['data']['out_trade_no']
          this.pay = res['data']['amount'] / 100
          this.type = res['data']['pay_type'] === 'wechat' ? '微信' : '支付宝'
          this.date = res['data']['pay_time']
          this.license = res['data']['license']
          this.booleanKey = res['data']['booleanKey']

          this.visible = this.license !== 'null'
        } else {
          this.$router.push('/pay')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
tr{
  padding-top: 15px;
}
.text-title{
  height: 100px;
  width: 100%;
  /*vertical-align:middle;*/
  line-height: 100px;/*垂直居中*/
  margin-left: 50px;/*左边留空*/
  display: flex;
  align-items: center;
}
.row-content{
  margin-left: 50px;/*左边留空*/
  margin-top: 30px;
  font-size: large;
  color:#AAAAAA;
}
.text-img{
  width: 50px;
  height: 50px;
  vertical-align: middle;
}
.bg-success{
  background-color: #fcf5ea;
  margin-bottom: 15px;
}
.content{
  margin-left: 30px;
}
.title{
  color: #AAAAAA;
  font-size: 18px;
  text-align: right;
}
.text-content{
  font-size: 16px;
  color: #444444;
  padding-left: 10px;/*左边留空*/
}
.code{
  width: 600px;
  height: auto;
  border: #cbcaca 1px solid;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 14px;
  padding-bottom: 16px;
  margin-top: 6px;
  margin-bottom: 10px;
  background-color: rgba(252, 250, 250, 0.76);
  font-size: 14px;

  /*这两行代码可以解决大部分场景下的换行问题*/
  word-break: break-all;
  word-wrap: break-word;
  /*但在有些场景中，还需要加上下面这行代码*/
  white-space: normal;
}
</style>

